import { useEffect } from 'react'
import { trackEvent } from '@/libs/functions/track'
import { getUrlParam } from '@/libs/functions/getValue'

const cookie = () => {
  const referrer = getUrlParam('referrer')
  useEffect(() => {
    trackEvent('error/cookie:mounted', {
      meta: {
        href: window.location.href,
        referrer: referrer || 'null',
      },
    })
  }, [referrer])
  return (
    <div>
      <p>您的浏览器访问受限！</p>
      <p>
        请前往手机设置-App-Safari浏览器-高级-阻止所有Cookie的开关改为关闭，然后将浏览器App关闭后重新进入活动页面。
      </p>
    </div>
  )
}

export default cookie
